// Title rendered as forged metal letters (chrome silver, rivet nail-heads,
// moving shine) laid on a tape-measure strip, flanked by crossed swords.
import { Sword } from "lucide-react";

export default function BrickTitle({ text, className = "" }) {
  return (
    <span
      role="text"
      aria-label={text}
      data-testid={`metal-title-${text.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`tape-measure inline-flex max-w-full min-w-0 items-center gap-1 sm:gap-3 px-2 sm:px-4 py-2 ${className}`}
    >
      <Sword
        aria-hidden="true"
        className="hidden sm:block h-[0.85em] w-[0.85em] shrink-0 text-[#64748B] -rotate-45"
        style={{ filter: "drop-shadow(0 1px 0 #F8FAFC)" }}
      />
      <span className="min-w-0 flex flex-wrap justify-center gap-x-[0.24em]">
        {text.split(" ").map((word, w) => (
          <span key={w} className="inline-block whitespace-nowrap">
            {[...word].map((ch, i) => (
              <span
                key={i}
                aria-hidden="true"
                className="font-brick-letter inline-block"
                style={{ animationDelay: `${(i * 0.12).toFixed(2)}s` }}
              >
                {ch}
              </span>
            ))}
          </span>
        ))}
      </span>
      <Sword
        aria-hidden="true"
        className="hidden sm:block h-[0.85em] w-[0.85em] shrink-0 text-[#64748B] rotate-45 -scale-x-100"
        style={{ filter: "drop-shadow(0 1px 0 #F8FAFC)" }}
      />
    </span>
  );
}
